module.exports = __webpack_public_path__ + "media/images/countrysquared/mp-87ac13e2e3eec91192bfaba1794955c3.svg";